export const SYNC_SELECTION_STATE = 'SYNC_SELECTION_STATE';
export const SYNC_WARMUP_CACHE_FOR = 'SYNC_WARMUP_CACHE_FOR';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const CACHE_INDIVIDUAL_OBJECTS_PERMISSIONS = 'CACHE_INDIVIDUAL_OBJECTS_PERMISSIONS';
export const CACHE_CRM_SEARCH_QUERY_PERMISSIONS = 'CACHE_CRM_SEARCH_QUERY_PERMISSIONS';
export const CACHE_CRM_SEARCH_QUERY_TOTAL_NUMBER_OF_OBJECTS = 'CACHE_CRM_SEARCH_QUERY_TOTAL_NUMBER_OF_OBJECTS';